import { ActivosRecientesComponent } from './components/getionActivosFijos/activos-recientes/activos-recientes.component';
import { InformacionVisitanteComponent } from './components/informacionVisitante/informacion-visitante.component';
import { FdSimpleMultiSelectComponent } from './components/fdSimpleMultiSelect/fd-simple-multiselect.component';
import { NotFoundComponent } from './components/notFound/not-found.component';
import { FdDatepickerRangeComponent } from './components/datePicker/fd-datepicker.component';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from './services/alert.service';
import { FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { CustomToastr } from './components/toastr/custom-toastr';
import { FdSelectComponent } from './components/fdSelect/fd-select.component';
import { TarjetaComponent } from './components/tarjeta/tarjeta.component';
import { ConfirmationModalComponent } from './components/modal/confirmationModal.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { WebcamModule } from 'ngx-webcam';
import { AutocompleteModule } from 'ng2-input-autocomplete';
import { NgxPaginationModule } from 'ngx-pagination';
import { OverlayModule } from '@angular/cdk/overlay';

import { ReactiveFormsModule } from '@angular/forms';
import { SearchPipe } from '../pipes/search.pipe';
import { ComponenteCameraComponent } from './components/informacionVisitante/componente-camera.component';
import { GestionActivoFijoComponent } from './components/getionActivosFijos/gestion-activo-fijo/gestion-activo-fijo.component';
import { TarjetaRegistroComponent } from './components/tarjeta-registro/tarjeta-registro.component';
import { UppercaseInputDirective } from '../pipes/uppercase.pipe';
import { OnlyLettersDirective } from '../pipes/onlyLetters.pipe';
import { MomentPipe } from '../pipes/moment.pipe';
import { OnlyLettersAndNumbersDirective } from '../pipes/onlyLettersAndNumbers.pipe';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { OnlyNumberDirective } from '../pipes/onlyNumber.pipe';
import { NoSpacesDirective } from '../pipes/noSpaces.pipe';
import { AnySpaceDirective } from '../pipes/anySpace.pipe';
import { NgMarqueeModule } from 'ng-marquee';
import { DatepickerComponent } from './components/datePicker/ajustado/datepicker.component';
import { LettersNumberDotDirective } from '../pipes/letterNumberDot.pipe';


@NgModule({
  declarations: [
    AnySpaceDirective,
    NoSpacesDirective,
    LettersNumberDotDirective,
    OnlyLettersAndNumbersDirective
    , OnlyLettersDirective
    , OnlyNumberDirective
    , UppercaseInputDirective
    , MomentPipe
    , SearchPipe
    , NotFoundComponent
    , CustomToastr
    , FdSelectComponent
    , TarjetaComponent
    , TarjetaRegistroComponent
    , ConfirmationModalComponent
    , FdDatepickerRangeComponent
    , FdSimpleMultiSelectComponent
    , InformacionVisitanteComponent
    , ComponenteCameraComponent
    , GestionActivoFijoComponent
    , ActivosRecientesComponent
    , TarjetaRegistroComponent
    , DatepickerComponent],

  imports: [
    NgMarqueeModule,
    NgxPaginationModule,
    OverlayModule,
    AutocompleteLibModule,
    ReactiveFormsModule,
    AutocompleteModule.forRoot(),
    // tslint:disable-next-line: deprecation
    NgbModule.forRoot(),
    CommonModule,
    FormsModule,
    WebcamModule,
    ToastrModule.forRoot(
      {
        toastComponent: CustomToastr,
        timeOut: 3000
      }
    ),
    NgxSpinnerModule
  ],
  entryComponents: [CustomToastr, ComponenteCameraComponent],
  exports: [
    NgxPaginationModule,
    OverlayModule,
    AnySpaceDirective,
    NoSpacesDirective,
    OnlyNumberDirective,
    OnlyLettersAndNumbersDirective,
    LettersNumberDotDirective
    , OnlyLettersDirective
    , FdSimpleMultiSelectComponent
    , NotFoundComponent
    , CustomToastr
    , FdSelectComponent
    , TarjetaComponent
    , TarjetaRegistroComponent
    , FormsModule
    , WebcamModule
    , ConfirmationModalComponent
    , InformacionVisitanteComponent
    , FdDatepickerRangeComponent
    , NgxSpinnerModule
    , ReactiveFormsModule
    , NgbModule
    , SearchPipe
    , GestionActivoFijoComponent
    , ActivosRecientesComponent
    , UppercaseInputDirective
    , MomentPipe
    , NgMarqueeModule
    , DatepickerComponent],
  providers: [AlertService, NgbActiveModal],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
